import { brandPresetStorage } from '../services/brandPresetStorage';

export const defaultBrandPresets = {
  wwsc: {
    id: 'wwsc',
    name: 'WWSC-OLP',
    domain: 'https://tools.working-with-street-children.org',
    primaryColor: '#2563eb',
    secondaryColor: '#1d4ed8',
    backgroundColor: '#f8fafc',
    textColor: '#ffffff',
    logoUrl: 'https://greta-preview.s3.us-east-2.amazonaws.com/assets/logo.svg',
    layout: {
      borderRadius: 16,
      showHeader: true,
      headerStyle: 'solid',
      shadow: 'shadow-lg'
    },
    isDefault: true,
    isEditable: true
  },
  heartForYouth: {
    id: 'heartForYouth',
    name: 'Heart-for-Youth',
    domain: '',
    primaryColor: '#dc2626',
    secondaryColor: '#991b1b',
    backgroundColor: '#fff1f2',
    textColor: '#ffffff',
    logoUrl: 'https://images.unsplash.com/photo-1516589178581-6cd7833ae3b2?q=80&w=100&auto=format&fit=crop',
    layout: {
      borderRadius: 12,
      showHeader: true,
      headerStyle: 'gradient',
      shadow: 'shadow-xl'
    },
    isDefault: true,
    isEditable: true
  },
  smartAppTools: {
    id: 'smartAppTools',
    name: 'SmartApp-Tools',
    domain: 'https://use.smartapp.tools',
    primaryColor: '#059669',
    secondaryColor: '#065f46',
    backgroundColor: '#f0fdf4',
    textColor: '#ffffff',
    logoUrl: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?q=80&w=100&auto=format&fit=crop',
    layout: {
      borderRadius: 24,
      showHeader: true,
      headerStyle: 'minimal',
      shadow: 'shadow-md'
    },
    isDefault: true,
    isEditable: true
  },
  streetRise: {
    id: 'streetRise',
    name: 'StreetRise International',
    domain: 'https://tools.streetrise-international.org',
    primaryColor: '#f59e0b',
    secondaryColor: '#d97706',
    backgroundColor: '#fffbeb',
    textColor: '#ffffff',
    logoUrl: 'https://images.unsplash.com/photo-1557804506-669a67965ba0?q=80&w=100&auto=format&fit=crop',
    layout: {
      borderRadius: 20,
      showHeader: true,
      headerStyle: 'gradient',
      shadow: 'shadow-2xl'
    },
    isDefault: true,
    isEditable: true
  },
  minimal: {
    id: 'minimal',
    name: 'Minimalist',
    domain: '',
    primaryColor: '#374151',
    secondaryColor: '#111827',
    backgroundColor: '#ffffff',
    textColor: '#ffffff',
    logoUrl: '',
    layout: {
      borderRadius: 8,
      showHeader: false,
      headerStyle: 'minimal',
      shadow: 'shadow-none'
    },
    isDefault: true,
    isEditable: true
  }
};

export const getAllBrandPresets = async () => {
  const customPresets = await brandPresetStorage.getAllCustomPresets();
  const editedDefaults = await brandPresetStorage.getEditedDefaults();
  
  // Merge edited defaults with original defaults
  const mergedDefaults = { ...defaultBrandPresets };
  Object.keys(editedDefaults).forEach(key => {
    mergedDefaults[key] = editedDefaults[key];
  });
  
  const customPresetsObj = {};
  customPresets.forEach(preset => {
    customPresetsObj[preset.id] = preset;
  });
  
  return { ...mergedDefaults, ...customPresetsObj };
};

export const getEmbedUrlForBrand = (slug, brandId, allPresets) => {
  const presets = allPresets || defaultBrandPresets;
  const brand = presets[brandId];
  const origin = brand?.domain || window.location.origin;
  return `${origin}/${slug}`;
};

export const brandPresets = defaultBrandPresets;